import React, { Component, useContext, useState } from "react";
import Axios from "axios";

import {
  Alert,
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  notification,
} from "antd";
import { BaseContext } from "../BaseContext";

const ChangePass = () => {
  const [form] = Form.useForm();

  const { token, user, email } = useContext(BaseContext);

  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [visibleError, setVisibleError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Change Password Success",
      description: "Password Successfully Changed ",
    });
  };

  const showDrawer = () => {
    setVisibleDrawer(true);
  };

  const onClose = () => {
    setVisibleDrawer(false);
  };

  const onFinish = (values) => {
    const { current_password, password, confirm_password } = values;

    if (current_password) {
      Axios.post("https://backendexample.sanbersy.com/api/change-password", {
        current_password: current_password,
        new_password: password,
        new_confirm_password: confirm_password,
        token: token,
      })
        .then((res) => {
          onClose();
          openNotificationWithIcon("success");
          form.resetFields();
        })
        .catch((err) => {
          setVisibleError(true);
          setErrorMessage(
            `there is an error in password change, please input your current password correctly! ${err}`
          );
        });
    }
  };

  return (
    <>
      <span
        style={{ cursor: "pointer", marginRight: "1rem" }}
        onClick={showDrawer}
      >
        Change Password
      </span>
      <Drawer
        title="Change Password"
        width={720}
        onClose={onClose}
        visible={visibleDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" form="myForm" key="submit" htmlType="submit">
              Change Password
            </Button>
          </div>
        }
      >
        {visibleError ? (
          <Alert type="error" message={errorMessage} banner closable />
        ) : (
            ""
          )}

        <Form
          layout="vertical"
          hideRequiredMark
          name="myForm"
          onFinish={onFinish}
          form={form}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="name" label="Name" initialValue={user}>
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="email" label="Email" initialValue={email}>
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="current_password"
                label="Current Password"
                rules={[
                  {
                    required: true,
                    min: 3,
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    min: 6,
                  },
                ]}
                hasFeedback
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="confirm"
                label="Confirm Password"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        "The two passwords that you entered do not match!"
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default ChangePass;
